// extracted by mini-css-extract-plugin
export default {"card":"index_card__OEmdz","shadow":"index_shadow__ip8gN","grayed":"index_grayed__1RyVP","filled":"index_filled__LVxNV","iconCard":"index_iconCard__d5rNR","meta":"index_meta__YzKbL"};